import { Component, computed, inject, input, Signal, signal, ViewChild } from "@angular/core";
import { EvLogoLoaderComponent } from "src/app/shared-components/ev-logo-loader/ev-logo-loader.component";
import { EvDropdownMenuComponent, ISearchDropDownItem } from "src/app/shared-components/ev-dropdown-menu/ev-dropdown-menu.component";
import { SaleInArea } from "src/models/estate/IResidenceSaleInArea";
import { MarketSalesDataService } from "src/services/estate/market-sales-data.service";
import { MarketSalesStateService } from "src/services/estate/market-sales-state.service";
import { EstateSaleItemComponent } from "./estate-sale-item.component";

@Component({
    selector: "estate-sales-list",
    imports: [EstateSaleItemComponent, EvLogoLoaderComponent, EvDropdownMenuComponent],
    templateUrl: "./estate-sales-list.component.html",
    styleUrl: "./estate-sales-list.component.scss",
})
export class EstateSalesListComponent {
    sales = input.required<SaleInArea[]>();
    marketSalesDataService: MarketSalesDataService = inject(MarketSalesDataService);
    marketSalesStateService: MarketSalesStateService = inject(MarketSalesStateService);
    selectedFilter = signal<string>("-sortDate");
    @ViewChild("searchResultDropDownCmp") searchResultDropDownCmp: any;

    filterOptions: Signal<ISearchDropDownItem[]> = computed(() => {
        return [
            {
                key: "sortDate",
                maintext: "Dato lav-høy",
                isSelected: false
            },
            {
                key: "-sortDate",
                maintext: "Dato høy-lav",
                isSelected: true
            },
            {
                key: "address",
                maintext: "Adresse A-Å",
                isSelected: false
            },
            {
                key: "-address",
                maintext: "Adresse Å-A",
                isSelected: false
            },
            {
                key: "residentialMeasuredArea",
                maintext: "Areal lav-høy",
                isSelected: false
            },
            {
                key: "-residentialMeasuredArea",
                maintext: "Areal høy-lav",
                isSelected: false
            },
            {
                key: "price",
                maintext: "Pris lav-høy",
                isSelected: false
            },
            {
                key: "-price",
                maintext: "Pris høy-lav",
                isSelected: false
            },
        ];
    });

    setFilter(selected: ISearchDropDownItem) {
        this.selectedFilter.set(selected.key as string);
        this.marketSalesStateService.sortOrderSignal.set(selected.key as string);
        sessionStorage.setItem("greenBeltCurrentSortItem", JSON.stringify(selected.key));
    }
}
